import React, {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react'
import Glider from 'react-glider'
import HeroHomeImg from './HeroHomeImg'
import useHeroHomeStyle from './styles/HeroHome.style'

type HeroCarouselProps = {
  heroCarousel: any[]
  isMobile: boolean
  isDesktopXL: boolean
  isTransparentMedia: string
  onSlideChange: (slideIndex: number) => void
}

const HeroCarousel = forwardRef<any, HeroCarouselProps>(
  (
    { heroCarousel, isMobile, isDesktopXL, isTransparentMedia, onSlideChange },
    ref
  ) => {
    const [activeSlide, setActiveSlide] = useState(0)
    const [isPaused, setIsPaused] = useState(false)
    const gliderRef = useRef<any>(null)
    const classes = useHeroHomeStyle()

    useImperativeHandle(ref, () => {
      return {
        scrollItem: (index: number) => {
          if (gliderRef.current) {
            gliderRef.current.scrollItem(index)
            // Manually trigger the slide change to update state
            setActiveSlide(index)
            onSlideChange(index)
          }
        },
      }
    })

    const handleSlideVisible = (event: CustomEvent) => {
      const slideIndex = event.detail?.slide || 0
      setActiveSlide(slideIndex)
      onSlideChange(slideIndex)
    }

    // Auto-scroll functionality
    useEffect(() => {
      if (!heroCarousel?.length || !gliderRef.current || isPaused) return

      const interval = setInterval(() => {
        if (gliderRef.current) {
          const currentSlide = activeSlide
          const nextSlide = (currentSlide + 1) % heroCarousel.length
          gliderRef.current.scrollItem(nextSlide)
        }
      }, 3000) // Change slide every 3 seconds

      return () => clearInterval(interval)
    }, [heroCarousel?.length, activeSlide, isPaused])

    return (
      <div
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
        className={isTransparentMedia}
      >
        <Glider
          ref={gliderRef}
          onSlideVisible={handleSlideVisible}
          scrollLock
          slidesToShow={1}
          duration={0.5}
          draggable
          itemWidth={0}
        >
          {heroCarousel?.map((item) => (
            <HeroHomeImg
              key={item.key}
              src={item.image}
              isMobile={isMobile}
              isDesktopXL={isDesktopXL}
              classes={classes.heightFull}
            />
          ))}
        </Glider>
      </div>
    )
  }
)

export default HeroCarousel
